import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import autobind from "autobind-decorator";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { Config } from "@/app/config";
import { AbstractSubmitStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import type { FormIncomeSimpleData } from "@/shared/ui";
import { FormIncomeSimple, ProgressButton } from "@/shared/ui";
import { formatText } from "@/shared/ui/format";

export interface StepFields {
	incomeList: FormIncomeSimpleData[];
}

export class Step5 extends AbstractSubmitStep<StepFields> {
	protected initValues(): StepFields {
		return {
			incomeList: [],
		};
	}

	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { submitState } = this.props;
		const disabled = this.isDisabled();

		return (
			<>
				<Card.Header>
					<Card.Title>Add meg, milyen havi jövedelmekkel rendelkezik a háztartásod!</Card.Title>
				</Card.Header>
				<Card.Body>
					<FormIncomeSimple
						name="incomeList"
						apiAddress={Config.getApiUrl("/api/public/bank/loan/mortgage/income-types")}
						validate={this.validIncomeList}
						disabled={disabled}
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
						state={submitState}
					>
						Tovább
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	@autobind
	private validIncomeList(incomeList: FormIncomeSimpleData[]): string {
		const totalIncome = incomeList.reduce((sum, income) => sum + income.amount, 0);

		if (totalIncome === 0) {
			return "Adj meg legalább egy jövedelmet!";
		}

		if (totalIncome < Config.getMinWage()) {
			return `A megadható minimális összjövedelem ${formatText(
				Config.getMinWage(),
				"ft",
			)}, amely megegyezik az aktuális minimálbérrel.`;
		}

		return undefined;
	}

	protected getComponentName(): string {
		return "Step5";
	}
}
